import React from 'react';

import DomUtils from '../../common/utils/DomUtils';

import PropertyPageView from '../../common/controls/PropertyPageView';

import SettingValuesView from './views/SettingValuesView';

import './SettingsView.css';

export default class SettingsView extends PropertyPageView {
  constructor(props) {
    super(props);

    this.viewRootElementId = `PwxSettingsView_${crypto.randomUUID()}`;

    this.viewRootElement = null;
    this.parentElement = null;
    this.resizeObserver = null;
  }

  getIntegratedPropertyNames() {
    return [
      'settingValues',
      'settingViewGroups'
    ];
  }

  componentDidMount() {
    this.viewRootElement = document.getElementById(this.viewRootElementId);
    this.parentElement = this.viewRootElement.parentElement;

    this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => this.updateViewHeight()));
    this.resizeObserver.observe(this.parentElement);

    this.updateViewHeight();
  }

  componentWillUnmount() {
    if (this.resizeObserver !== null) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    this.parentElement = null;
    this.viewRootElement = null;
  }

  render() {
    return (
      <div id={this.viewRootElementId} className="pwx-settings-view">
        <SettingValuesView
          settingValues={this.state.settingValues}
          settingViewGroups={this.state.settingViewGroups}
        />
      </div>
    );
  }

  updateViewHeight() {
    if (this.parentElement === null)
      return;

    DomUtils.setElementMaxHeight(
      this.viewRootElement,
      DomUtils.calculateInnerContentHeight(this.parentElement)
    );
  }
}